import { useSyncExternalStore } from 'react';

/** Below CoreUI's `lg` breakpoint, where the sidebar overlays the page (CoreUI 5 sets `--cui-is-mobile` there). */
const MOBILE_QUERY = '(max-width: 991.98px)';

const subscribe = (onChange: () => void) => {
  const query = window.matchMedia(MOBILE_QUERY);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
};

const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;

/** Whether the viewport is below the `lg` breakpoint. */
const useIsMobile = () => useSyncExternalStore(subscribe, isMobile);

export default useIsMobile;
